<template>
  <div class="modal-box">
    <div class="sign-up-form" v-show="showForm(1)">
      <span>{{ $t('searchForm.pleaseFillForm') }} (1/3)</span>
      <span class="line-break"></span>

      <div class="row">
        <div class="column medium-5">
          <div class="row">
            <div class="medium-12 column">
              <div class="logo-box" @click="$refs.fileUpload.click()">
                <div class="img-box">
                  <span class="recommended" v-show="!corporateInfo.logo">{{ $t('searchForm.recommendedSize') }} 200px by 200px</span>
                  <img :src="corporateInfo.logo" v-if="corporateInfo.logo" alt="Upload Corporate Logo">
                  <i class="fas fa-user-circle" v-else v-show="!upload.loading"></i>
                  <transition name="slide-up">
                    <i class="fa fa-spinner fa-spin fa-2x" v-show="upload.loading"></i>
                  </transition>
                </div>
                <input type="file" ref="fileUpload" style="display: none" @change="uploadFile" />
              </div>
              <span class="error-msg">{{ validation.logo }}</span>
            </div>
          </div>
        </div>
        <div class="column medium-7">
          <div class="row">
            <div class="column medium-12">
              <div class="label">{{ $t('common.username') }}</div>
              <input type="text" v-model="corporateInfo.username" :disabled="loading">
              <span class="error-msg">{{ validation.username }}</span>
            </div>
          </div>

          <div class="row">
            <div class="column medium-6">
              <div class="label">{{ $t('common.password') }}</div>
              <input type="password" v-model="corporateInfo.password" :disabled="loading">
              <span class="error-msg">{{ validation.password }}</span>
            </div>
            <div class="column medium-6">
              <div class="label">{{ $t('common.rpassword') }}</div>
              <input type="password" v-model="repeatPassword">
              <span class="error-msg">{{ validation.repeatPassword }}</span>
            </div>
          </div>

          <div class="row">
            <div class="column medium-12">
              <div class="label">{{ $t('common.mobile') }}</div>
              <div class="input-group">
                <div class="country-select input-group-label" @click="selectCountry">
                  <span class="country-code">(+{{corporateInfo.countryCode}}) </span>
                  <i class="fa fa-caret-down"></i>
                </div>
                <input type="number" v-model="corporateInfo.mobile" :disabled="loading">
              </div>
              <div class="country-list-wrap" v-show="showCountryDiv">
                <ul class="country-list">
                  <li>
                    <input type="text" ref="inputMobileSearch" v-focus="showCountryDiv" v-model="inputMobileSearch" >
                  </li>
                  <li @click="updateCountryCode(country.dialCode)" v-for="country in countryList" class="country" :key="country.code" v-show="countryFilter(country.name)">
                    <div class="flag-box">
                      <div :class="'iti-flag ' + country.code"></div>
                    </div>
                    <span class="country-name">{{ country.name }}</span>
                    <span class="dial-code">(+{{ country.dialCode }})</span>
                  </li>
                </ul>
              </div>
              <span class="error-msg">{{ validation.mobile }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="column medium-12">
          <div class="label">{{ $t('searchForm.corporateName') }}</div>
          <input type="text" v-model="corporateInfo.name" :disabled="loading">
          <span class="error-msg">{{ validation.name }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column medium-6">
          <div class="label">{{ $t('common.email') }}</div>
          <input type="email" id="email" v-model="corporateInfo.email" :disabled="loading">
          <span class="error-msg">{{ validation.email }}</span>
        </div>
        <div class="column medium-6">
          <div class="label">{{ $t('searchForm.website') }}</div>
          <input type="text" v-model="corporateInfo.website" :disabled="loading">
          <span class="error-msg">{{ validation.website }}</span>
        </div>
      </div>

    </div>

    <div class="sign-up-form" v-show="showForm(2)">
      <span>{{ $t('searchForm.billingInfo') }} (2/3)</span>
      <span class="line-break"></span>

      <div class="row">
          <div class="medium-12 column">
            <div class="data-field">
              <div class="label">{{ $t('searchForm.creditCard') }} #</div>
              <div class="credit-card-input">
                <input type="text" class="input" :disabled="loading"
                  v-model="creditCardData.card" @keyup="cardTypeCheck" />
                <span :class="['cc-icon', cardType]"></span>
              </div>
              <span class="error-msg">{{ validation.card }}</span>
            </div>
          </div>

          <div class="medium-12 column">
            <div class="data-field">
              <div class="label">{{ $t('searchForm.cardName') }}</div>
              <input type="text" class="input" :disabled="loading"
                v-model="creditCardData.owner" />
              <span class="error-msg">{{ validation.owner }}</span>
            </div>
          </div>

          <div class="medium-6 column">
            <div class="data-field">
              <div class="label">{{ $t('searchForm.exp') }} (MM/YYYY)</div>
              <input type="text" class="input" :disabled="loading"
                v-model="creditCardData.expiration"
                v-on:keyup="formatExpCC" v-on:keypress="isNumber" />
              <span class="error-msg">{{ validation.expiration }}</span>
            </div>
          </div>

          <div class="medium-6 column">
            <div class="data-field">
              <div class="label">{{ $t('searchForm.cvv') }}</div>
              <input type="text" class="input" :disabled="loading"
                v-model="creditCardData.cvv" v-on:keypress="isNumber" />
              <span class="error-msg">{{ validation.cvv }}</span>
            </div>
          </div>
      </div>

      <div class="row">
        <div class="column medium-12">
          <div class="label">{{ $t('searchForm.addr1') }}</div>
          <input type="text" v-model="corporateInfo.billingAddress1" :disabled="loading">
          <span class="error-msg">{{ validation.billingAddress1 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column medium-12">
          <div class="label">{{ $t('searchForm.addr2') }}</div>
          <input type="text" v-model="corporateInfo.billingAddress2" :disabled="loading">
          <span class="error-msg">{{ validation.billingAddress2 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column medium-12">
          <div class="label">{{ $t('searchForm.city') }}</div>
          <input type="text" v-model="corporateInfo.billingCity" :disabled="loading">
          <span class="error-msg">{{ validation.billingCity }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column medium-6 no-margin">
          <div class="label">{{ $t('searchForm.state') }}</div>
          <select v-model="corporateInfo.billingState" :disabled="loading">
            <option value="" selected></option>
            <option value="NonUS">{{ $t('searchForm.nonUs') }}</option>
            <option v-for="state in states" :value="state.label" :key="state.value">{{state.label}}</option>
          </select>
          <span class="error-msg">{{ validation.billingState }}</span>
        </div>
        <div class="column medium-6">
          <div class="label">{{ $t('searchForm.zip') }}</div>
          <input type="number" v-model="corporateInfo.billingZip" :disabled="loading">
          <span class="error-msg">{{ validation.billingZip }}</span>
        </div>
      </div>

      <div class="row" v-show="corporateInfo.billingState === 'NonUS'">
        <div class="column medium-12">
          <div class="label">{{ $t('searchForm.country') }}</div>
          <select v-model="corporateInfo.billingCountry" :disabled="loading"
            :class="{'input':true, 'has-error':false}">
            <option v-for="(country, index) in billingCountries"
              :key="index" :value="country.code">{{country.name}}</option>
          </select>
          <span class="error-msg">{{ validation.billingCountry }}</span>
        </div>
      </div>

    </div>

    <div class="sign-up-form" v-show="showForm(3)">
      <div class="review-box">
        <span>{{ $t('searchForm.reviewDetails') }} (3/3)</span>
        <span class="line-break"></span>
        <div class="row">
          <div class="medium-12 column">
            <div class="basic-info">
              <div><b>{{ $t('common.username') }}: </b> {{corporateInfo.username}}</div>
              <div><b>{{ $t('searchForm.corporateName') }}: </b> {{corporateInfo.name}}</div>
              <div>
                <b>{{ $t('common.email') }}: </b> {{corporateInfo.email}}
              </div>
              <div>
                <b>{{ $t('common.mobile') }}: </b> (+{{corporateInfo.countryCode}}) {{corporateInfo.mobile}}
              </div>
              <div>
                <b>{{ $t('searchForm.website') }}: </b> {{corporateInfo.website}}
              </div>
            </div>

            <div class="address">
              <b>{{ $t('searchForm.addr') }}:</b>
              <span>{{corporateInfo.billingAddress1}}</span>
              <span>{{corporateInfo.billingAddress2}}</span>
              <span>{{corporateInfo.billingCity}}</span>
              <span v-if="corporateInfo.billingState !== 'NonUS'">{{corporateInfo.billingState}}, {{corporateInfo.billingZip}}</span>
              <span v-else>{{findCountry(corporateInfo.billingCountry)}}, {{corporateInfo.billingZip}}</span>
            </div>
          </div>
        </div>
      </div>

      <transition name="slide-down">
        <div class="loading-box" v-show="submitting">
          <div class="vcenter">
            <div class="vcenter-content">
              <div class="loading">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
                <span>{{ $t('searchForm.submitting') }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="slide-up">
        <div class="response-box" v-show="!submitting && response.success">
            <div class="vcenter">
              <div class="vcenter-content">
              <div class="checkmark-circle">
                <div class="background"></div>
                <div class="checkmark draw start"></div>
              </div>
              <span class="message">
                <b>{{ $t('searchForm.thankYouSignup') }}</b>
                {{ $t('searchForm.yourCorporate') }}
              </span>
              <div class="ok-box">
                <div class="op-btn btn-lg btn-success btn-block margin-t-m" @click="refresh">{{ $t('searchForm.ok') }}</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="sign-up">
      <div class="row" v-if="response.show && !response.success && formNumber === 3">
        <div class="response-error-msg">{{ response.message }}</div>
      </div>
      <div class="row" v-show="!response.success">
        <div class="column medium-6 small-6">
          <a :class="{'op-btn btn-lg btn btn-block margin-t-m':true, 'disabled':submitting}"
            @click="backForm" v-show="formNumber > 1" :disabled="loading || submitting">
            <i class="fas fa-chevron-left"></i> {{ $t('common.back') }}
          </a>
        </div>
        <div class="column medium-6 small-6" v-if="formNumber < 3">
          <a :class="['op-btn btn-lg btn-success btn-block margin-t-m']"
            @click="nextForm" :disabled="loading || submitting">
            {{ $t('common.next') }} <i class="fas fa-chevron-right"></i>
          </a>
        </div>
        <div class="column medium-6 small-6" v-else>
          <a :class="{'op-btn btn-lg btn-success btn-block margin-t-m':true, 'disabled':submitting}"
            @click="submit" :disabled="loading || submitting">{{ $t('common.submit') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import US from 'us'
import creditCardType, { types as CardType } from 'credit-card-type';
import uuidv4 from 'uuid/v4'

const countries = require('@/data/countries')

export default {
  name: 'signup-form',
  data () {
    return {
      formNumber: 1,
      upload: {
        loading: false,
        message: ''
      },
      showCountryDiv: false,
      validation: {
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        mobile: '',
        email: '',
        website: '',
        card: '',
        owner: '',
        expiration: '',
        cvv: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        billingCountry: '',
        billingZip: '',
        logo: ''
      },
      repeatPassword: '',
      countryList: [],
      inputMobileSearch: null,
      cardType: 'unknown',
      fileChanged: false,
      response: {
        show: false,
        success: false,
        message: ''
      },
      submitting: false
    }
  },
  watch: {
    'corporateInfo.billingState': function (val) {
      if (val && val !== 'NonUS') {
        this.corporateInfo.billingCountry = 'us'
      }
    }
  },
  computed: {
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    billingCountries () {
      let dataCountries = require('@/data/countries')
      let countries = []
      for (let country in dataCountries) {
        countries.push({
          name: dataCountries[country].name,
          code: dataCountries[country].code
        })
      }
      return countries
    },
    corporateInfo () { return this.$store.state.loginSignup.profile.info },
    loading () { return this.$store.state.loginSignup.profile.loading },
    creditCardData () { return this.$store.state.loginSignup.profile.creditCard },
    noImageYet () {
      if (this.formNumber === 1) {
        return !this.corporateInfo.logo
      }
      return false
    }
  },
  methods: {
    showForm (form) {
      let self = this
      if (form === self.formNumber) {
        return true
      } else {
        return false
      }
    },
    nextForm () {
      let self = this
      if (!self.validate()) { return }
      self.formNumber = self.formNumber + 1
    },
    backForm () {
      let self = this
      if (self.submitting) { return }
      self.formNumber = self.formNumber - 1
      self.response = {
        show: false,
        success: false,
        message: ''
      }
    },
    selectCountry () {
      this.showCountryDiv = !this.showCountryDiv
      this.sortCountries()
    },
    findCountry (country) {
      let dataCountries = require('@/data/countries')
      let countryName = ''
      for (let key in dataCountries) {
        if (key === country) {
          countryName = dataCountries[key].name
          break
        }
      }
      return countryName
    },
    sortCountries () {
      let country = Object.values(countries)
      let displayCountry = []
      country = country.sort((a, b) => (a.name > b.name) ? 1 : -1)

      let topCountries = ['us', 'ca', 'gb']
      topCountries.forEach(x => {
        displayCountry.push(...country.filter(y => y.code === x))
      })
      topCountries.forEach(x => {
        country = country.filter(y => y.code !== x)
      })
      displayCountry.push(...country)

      this.countryList = displayCountry
    },
    updateCountryCode (dialCode) {
      this.corporateInfo.countryCode = dialCode
      this.showCountryDiv = false
    },
    countryFilter (val) {
      let countryName = val.toLowerCase()
      let regex = new RegExp(this.inputMobileSearch, 'gi')
      if (countryName.match(regex) || this.inputMobileSearch === null || this.inputMobileSearch === '') {
        return true
      } else {
        return false
      }
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    formatExpCC () {
      let cardExp = this.creditCardData.expiration
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.creditCardData.expiration = cardExp + '/'
      }
    },
    cardTypeCheck () {
      if (this.creditCardData.card === '') {
        this.cardType = 'unknown'
        return
      }

      let possibleCards = creditCardType(this.creditCardData.card);
      this.cardType = 'unknown'

      for (let i = 0; i < possibleCards.length; i++) {
        let possibleCard = possibleCards[i]
        let cardType = possibleCard.type

        if (cardType === CardType.VISA) {
          this.cardType = 'visa'
        } else if (cardType === CardType.MASTERCARD) {
          this.cardType = 'mastercard'
        } else if (cardType === CardType.AMERICAN_EXPRESS) {
          this.cardType = 'amex'
        } else if (cardType === CardType.DINERS_CLUB) {
          this.cardType = 'dinersclub'
        } else if (cardType === CardType.DISCOVER) {
          this.cardType = 'discover'
        } else if (cardType === CardType.JCB) {
          this.cardType = 'jcb'
        }
      }
    },
    validate () {
      let noError = true
      let self = this

      if (this.upload.message !== '') {
        noError = false
      }

      if (this.formNumber === 1) {
        let fieldCheck = {
          username: '',
          password: '',
          repeatPassword: '',
          name: '',
          mobile: '',
          email: '',
          corporateEmail: '',
          website: ''
        }
        for (let field in fieldCheck) {
          this.validation[field] = ''
          if (this.corporateInfo[field] === '') {
            this.validation[field] = self.$t('common.fieldEmpty')
            noError = false
          }
        }
        if (this.corporateInfo.logo === '') {
          this.validation.logo = self.$t('searchForm.pleaseUpload')
          noError = false
        }
      }

      if (this.formNumber === 2) {
        let fieldCheck = {
          card: '',
          owner: '',
          expiration: '',
          cvv: '',
          billingAddress1: '',
          billingCity: '',
          billingState: '',
          billingCountry: '',
          billingZip: ''
        }
        for (let field in fieldCheck) {
          this.validation[field] = ''
          if (this.corporateInfo[field] === '' || this.creditCardData[field] === '') {
            this.validation[field] = self.$t('common.fieldEmpty')
            noError = false
          }
        }
      }

      if (this.corporateInfo.username.indexOf(' ') > -1) {
        this.validation.username = self.$t('searchForm.spaceNotAllowed')
        noError = false
      }

      const email = document.getElementById('email');
      if (!email.validity.valid) {
        this.validation.email = self.$t('searchForm.validEmail')
        noError = false
      }

      if (this.repeatPassword === '') {
        this.validation.repeatPassword = self.$t('common.fieldEmpty')
        noError = false
      }

      if (this.repeatPassword !== '' && this.corporateInfo.password !== '' &&
        this.repeatPassword !== this.corporateInfo.password
      ) {
        this.validation.repeatPassword = self.$t('searchForm.passwordNotMatch')
        noError = false
      }

      return noError
    },
    uploadFile (e) {
      if (!e.target.files.length) return

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.$store.commit('loginSignup/setSignupLoading', true)

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.$store.commit('loginSignup/setSignupLoading', false)
        if (!res.body.success) {
          self.response = {
            show: true,
            success: false,
            message: self.$t('searchForm.uploadImgFail')
          }
          return
        }

        self.$store.commit('loginSignup/setProfileInfo', {
          field: 'logo',
          value: res.body.data.url
        })
      }, function (res) {
        self.response = {
          show: true,
          success: false,
          message: res
        }
      })
    },
    submit () {
      let self = this
      if (self.submitting) return

      let token = 'CORP-' + uuidv4()
      self.submitting = true
      self.$store.commit('loginSignup/setSignupLoading', true)
      self.response = {
        show: false,
        success: false,
        message: ''
      }

      let mobile = '+' + self.corporateInfo.countryCode + self.corporateInfo.mobile

      self.$sdk.post(self, '/auth/signup/corporate', {
        token: token,
        logoUrl: self.corporateInfo.logo,
        name: self.corporateInfo.name,
        username: self.corporateInfo.username,
        password: self.corporateInfo.password,
        contactEmail: self.corporateInfo.email,
        contactPhone: mobile,
        billingAddress1: self.corporateInfo.billingAddress1,
        billingAddress2: self.corporateInfo.billingAddress2,
        billingCity: self.corporateInfo.billingCity,
        billingState: self.corporateInfo.billingState,
        billingZip: self.corporateInfo.billingZip,
        billingCountry: self.corporateInfo.billingCountry.toUpperCase(),
        corporateColor: self.corporateInfo.color,
        corporateWebsiteUrl: self.corporateInfo.website,
        active: false,
        card: {
          title: '',
          name: self.creditCardData.owner,
          number: self.creditCardData.card,
          expiration: self.creditCardData.expiration,
          cvv: self.creditCardData.cvv,
          billingAddress: self.corporateInfo.billingAddress1,
          billingCity: self.corporateInfo.billingCity,
          billingState: self.corporateInfo.billingState,
          billingCountry: self.corporateInfo.billingCountry,
          billingZip: self.corporateInfo.billingZip
        },
        d2d: 1
      }, res => {
        self.submitting = false
        self.$store.commit('loginSignup/setSignupLoading', false)
        if (res.error) {
          self.response = {
            show: true,
            success: false,
            message: res.error.message
          }
          return
        }

        self.response = {
          show: true,
          success: true,
          message: ''
        }
      })
    },
    resetResponse () {
      this.response = {
        show: false,
        success: false,
        message: ''
      }
    },
    refresh () {
      let loc = window.location.href
      let index = loc.indexOf('#')
      window.location.href = loc.substring(0, index) + '#'
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/vendor/intlTelInput/css/intlTelInput.css";
@import "../../assets/scss/Review/ThankYou.scss";

.no-margin {
  margin: 0 !important;
}
.modal-box {
  & .line-break {
    border: 1px solid rgba(223, 223, 223, 0.6);
    border-bottom-width: thin;
    display: block;
    margin: 15px 0;
  }
  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 5px;
  }
  .column {
    padding: 0 5px;
    margin-bottom: 7px;
  }
  .label {
    font-size: 13px;
    text-align: left;
  }
  input {
    margin: 0;
    color: #333;
    line-height: inherit;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
    width: 100%;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 40.4px;
    border-radius: 0;
    width: 100%;
    border: none;
    border: 1px solid #ccc;
    padding: 10px;
    background: #fbfbfb;
    color: #444;
    outline: none;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s linear;
    transition: all .3s linear;
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
  select{
    border: 1px solid #ccc;
    padding: 10px;
    color: #333;
    height: 41px;
    position: relative;
    font-size:16px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    background: #fbfbfb;
    outline: none;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s linear;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }

  .input-group {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    position: relative;
    margin-bottom: 0;
    flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;

    .input-group-label {
      padding: 0 10px;
      border: 1px solid #cacaca;
      background: #f4f8f9;
      color: #0a0a0a;
      text-align: center;
      white-space: nowrap;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .country-select {
      cursor: pointer;
      color: #333;
      transition: 0.3s;
      height: 40px;
      width: auto;
    }
    .country-select:hover {
      background-color: #e6e6e6;
    }
    .country-code {
      margin-right: 3px;
      font-weight: 100;
      font-size: 15px;
    }
  }

  .country-list-wrap {
    border: 1px solid #ccc;
    position: absolute;
    z-index: 2;
    background-color: #fff;
    height: 185px;
    overflow-y: auto;

    ul {
      margin: 0;
      padding: 10px;
    }
    li {
      list-style: none;
    }
    .country {
      padding: 5px 0;

      div {
        display: inline-block;
        width: 20px;
        margin-right: 4px;
      }
      &:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .basic-info, .address {
    border: 1px solid #ddd;
    padding: 15px;
    background-color: rgba(0,0,0,0.1);
  }

  .address {
    margin-top: 20px;
    span {
      display: block;
    }
  }

  .credit-card-input{
    position: relative;

    .cc-icon{
      background-image: url('https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png');
      background-repeat: no-repeat;
      background-size: cover;
      height: 20px;
      width: 32px;
      display: inline-block;

      &.unknown{ background-position: 0 0; }
      &.visa{ background-position: 0 -20px; }
      &.mastercard{ background-position: 0 -40px; }
      &.amex{ background-position: 0 -60px; }
      &.discover{ background-position: 0 -80px; }
      &.jcb{ background-position: 0 -100px; }
      &.diners{ background-position: 0 -120px; }
      position: absolute;
      top: 10px;
      left: 9px;
      z-index: 20;
    }
    input{ padding-left: 43px; }
  }
  .button{ margin: 20px 0 10px; }
  .close{
    font-size: 14px;
    color: #888;
    cursor: pointer;
  }

}
.sign-up-form{
  padding: 20px;
  position: relative;
  padding-bottom: 0;
  padding-top: 6px;
}

.sign-up { padding: 0 20px 10px; }

.logo-box {
  text-align: center;

  .img-box {
    border: 2px dashed #ddd;
    padding: 10px;
    transition: .2s ease all;

    .recommended {
      font-size: 13px;
    }

    i {
      font-size: 130px;
      color: #a9a9a9;
    }

    &:hover {
      cursor: pointer;
      background-color: #dedede;

      i {
        color: #fff;
      }
    }
  }

  .error-msg{
    display: block;
    font-weight: 100;
    margin-top: 2px;
    color: #f20d0d;
    font-size: 12px;
    font-style: italic;
  }
}

@media only screen and (max-width: 420px) {
  .modal-box {
    height: 80vh;
    overflow-y: auto;
  }
}

.vcenter{
  display: table;
  width: 100%;
  height: 100%;

  .vcenter-content{
    display: table-cell;
    vertical-align: middle;
  }
}

.review-box{
  position: relative;
  z-index: 2;
}

.loading-box{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 3;
  background: rgba(255,255,255,.7);

  .fa-spinner{ vertical-align: middle; }
  span{
    font-size: 28px;
    margin-left: 5px;
    display: inline-block;
    vertical-align: middle;
  }
}
.response-box{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: #fff;

  .message{
    font-size: 14px;
    display: block;
    text-align: center;
    padding: 10px 30px;

    b{
      display: block;
      font-size: 18px;
      margin-bottom: 10px;
      line-height: 1;
    }
  }
  .ok-box{ margin: 0 25px; }
}
.response-error-msg{
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #f20d0d;
  background: #fdebeb;
  font-size: 13px;
  border-radius: 2px;
  line-height: 1;
  color: #f20d0d;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease-out; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-15px);
  opacity: 0;
}
.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease-out; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// SignupForm.vue?32d0632c